
const TextFieldSuffixType = {
  CLEAR: 'TextFieldSuffixType::CLEAR',
}

export default TextFieldSuffixType
